import { QueryCache, QueryClient, QueryClientProvider, QueryMeta } from '@tanstack/react-query';
import * as React from 'react';
import { toast } from 'sonner';
import { EventLogger, IEventArgs } from '../extViewmodels';

export interface LevStandardQueryMeta extends QueryMeta {
	toastErrorMessage?: string | ((error: Error) => string);
	errorLogging?: IEventArgs;
}

export const reactQueryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			if (!query.meta) {
				return;
			}
			const meta = query.meta as LevStandardQueryMeta;
			if (meta.toastErrorMessage) {
				toast.error(
					typeof meta.toastErrorMessage === 'function' ? meta.toastErrorMessage(error) : meta.toastErrorMessage
				);
			}
			if (meta.errorLogging) {
				EventLogger.logEvent(meta.errorLogging, {
					error,
				});
			}
		},
	}),
});
export function ReactQueryProvider({ children }: { children: React.ReactNode }) {
	return <QueryClientProvider client={reactQueryClient}>{children}</QueryClientProvider>;
}
